import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "bg-slate-700 text-slate-100 -mx-2 h-full"
};
const _hoisted_2 = {
  class: "py-4"
};
const _hoisted_3 = {
  class: "text-3xl flex-center"
};
const _hoisted_4 = {
  class: "flex-center mb-4"
};
const _hoisted_5 = {
  class: "flex-center text-4xl mono uppercase mb-4"
};
const _hoisted_6 = {
  class: "flex-center flex-col bg-slate-50 p-4 rounded-xl"
};
const _hoisted_7 = {
  class: "flex-center"
};
import DefaultInGameLayout from "@/modules/base/layouts/DefaultInGameLayout.vue";
import { Player } from "@/modules/team/entity";
import { app } from "@/di";
import GlobalResolver from "@/modules/base/services/GlobalResolver";
import Flag from "@/modules/vue/components/Flag.vue";
import CareerStats from "@/modules/team/components/CareerStats.vue";
import { CompetitionPlayerLog } from "@/modules/competitions/entity";
import PlayerInfo from "@/modules/team/components/PlayerInfo.vue";
import Talent from "@/modules/youth/components/Talent.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'CareerEndedPage',
  async setup(__props) {
    let __temp, __restore;
    const players = ref();
    const stats = ref();
    const route = useRoute();
    const {
      refresh
    } = ([__temp, __restore] = _withAsyncContext(async () => useInitial(async () => {
      const ids = route.query.ids;
      players.value = await Player.createQueryBuilder('player').innerJoinAndSelect('player.country', 'country').innerJoinAndSelect('country.region', 'region').where(`player.id IN (${ids.map(id => id).join(',')})`).getMany();
      stats.value = await CompetitionPlayerLog.createQueryBuilder('log').innerJoin('log.player', 'player').where(`player.id IN (${players.value.map(p => p.id).join(',')})`).getMany();
    })), __temp = await __temp, __restore(), __temp);
    const onContinue = async () => {
      app.get(GlobalResolver).resolvePromise();
    };
    return (_ctx, _cache) => {
      const _component_NCarouselItem = _resolveComponent("NCarouselItem");
      const _component_NCarousel = _resolveComponent("NCarousel");
      const _component_NButton = _resolveComponent("NButton");
      return _openBlock(), _createBlock(DefaultInGameLayout, {
        "hide-tabbar": "",
        "hide-footer": ""
      }, {
        title: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('end_of_career')), 1)]),
        subtitle: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('x_players_end_their_careers', {
          x: players.value.length
        })), 1)]),
        footerButtons: _withCtx(() => [_createVNode(_component_NButton, {
          type: "success",
          secondary: "",
          size: "large",
          onClick: onContinue,
          textContent: _toDisplayString(_ctx.$t('continue'))
        }, null, 8, ["textContent"])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_NCarousel, {
          "space-between": 30,
          loop: false,
          "slides-per-view": "auto",
          "centered-slides": "",
          class: "h-full",
          "show-arrow": "",
          "dot-type": "line"
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(players.value, (player, i) => {
            return _openBlock(), _createBlock(_component_NCarouselItem, {
              key: i,
              style: {
                width: `90%`
              }
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, _toDisplayString(player.name) + " (" + _toDisplayString(player.age) + ") ", 1), _createElementVNode("div", _hoisted_4, [_createVNode(Flag, {
                country: player.country,
                class: "mr-2"
              }, null, 8, ["country"]), _createTextVNode(" " + _toDisplayString(player.country.name) + ", " + _toDisplayString(player.country.region.name), 1)]), _createElementVNode("div", _hoisted_5, _toDisplayString(player.position), 1), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createVNode(PlayerInfo, {
                class: "mr-2"
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(Math.floor(player.skill)), 1)]),
                _: 2
              }, 1024), _createVNode(PlayerInfo, null, {
                default: _withCtx(() => [_createVNode(Talent, {
                  talent: player.talent,
                  size: "3rem"
                }, null, 8, ["talent"])]),
                _: 2
              }, 1024)])]), _createVNode(CareerStats, {
                stats: stats.value.filter(s => s.playerId === player.id),
                class: "my-4"
              }, {
                title: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('total')), 1)]),
                _: 2
              }, 1032, ["stats"])])]),
              _: 2
            }, 1024);
          }), 128))]),
          _: 1
        })])]),
        _: 1
      });
    };
  }
});